function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5219 0H8.37065V13.5793H21.9945V3.53305C22 1.62553 20.4357 0 18.5219 0ZM5.25315 0H3.55018C1.63641 0 0 1.55366 0 3.53858V5.23599H5.25315V0ZM0 8.41518H5.25315V13.6512H0V8.41518ZM16.7468 21.9945H18.4498C20.3636 21.9945 22 20.4408 22 18.4559V16.764H16.7468V21.9945ZM8.37065 16.764H13.6238V22H8.37065V16.764ZM0 16.764V18.4614C0 20.3689 1.55875 22 3.55018 22H5.25315V16.764H0Z",
  fill: "black"
});

var SvgLedger = function SvgLedger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLedger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ledger.41f3d9d7.svg";
export { ForwardRef as ReactComponent };